const variableStyles = {
  // theme
  darkTheme: '#0b1d42',
  lightTheme: '#FFFFFF',
};

export default variableStyles;